import {
    Accordion, AccordionDetails, AccordionSummary,
    Icon, Stack, Typography, Box, Divider
} from '@mui/material'

import {Fragment, useEffect, useState} from 'react'
import { useSelector } from 'react-redux'

import { useServiceHealth } from '@features/hooks/LandingZones/serviceHealth'

import Tag from '@components/Tag'

export const Status = () => {
    const dataStore = useSelector(state => state.serviceHealth)

    const { load: loadStatus } = useServiceHealth()

    const STATUS = {
        Healthy: {
            icon: 'check_circle',
            color: 'success'
        },
        Unhealthy: {
            icon: 'build_circle',
            color: 'warning'
        }
    }

    const [health, setHealth] = useState({})

    useEffect(() => {
        if (!dataStore.loaded) loadStatus()
    }, [])

    useEffect(() => {
        if (Object.keys(dataStore.data).length < 1) return
        const data = dataStore.data

        setHealth({
            azureHealth: STATUS[data.azureHealth ?? 'Unhealthy'],
            apiHealth: STATUS[data.apiHealth ?? 'Unhealthy'],
            connectivityHealth: STATUS[data.connectivityHealth ?? 'Unhealthy'],
            header: formatHeader(data)
        })
    }, [dataStore.data])

    const formatHeader = (data) => {
        const result = { maintenance: 0, operational: 0 }

        Object.values(data).forEach(status => {
            if (status === "Unhealthy") result.maintenance++
            else if (status === "Healthy") result.operational++
        })

        return result
    }

    return (
        <Box sx={{pl: 2, pr: 2, pt: 1, mb: 2}}>
            <Accordion defaultExpanded={false}>
                <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{width: '100%', marginRight: 1}}>
                        <Typography variant={'h6'}>Platform status</Typography>
                        <Stack spacing={1} direction={'row'} alignItems={'center'}>
                            {(health.header?.maintenance > 0) && (
                              <Fragment>
                                  <Typography variant={'h6'}>{health.header?.maintenance}</Typography>
                                  <Tag chip={{icon: (<Icon>build_circle</Icon>)}} label={'Maintenance'} color={'yellow'}/>
                              </Fragment>
                            )}
                            {(health.header?.maintenance > 0 && health.header?.operational > 0) && (
                                <Divider orientation={'vertical'} variant={'middle'} flexItem />
                            )}
                            {(health.header?.operational > 0) && (
                                <Fragment>
                                    <Typography variant={'h6'}>{health.header?.operational}</Typography>
                                    <Tag chip={{icon: (<Icon>check_circle</Icon>)}} label={'Operational'} color={'green'}/>
                                </Fragment>
                            )}
                        </Stack>
                    </Stack>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack>
                        <Stack direction={'row'} justifyContent={'space-between'}  alignItems={'center'} sx={{mb: 1}}>
                            <Typography variant={'body2'}>Azure Health</Typography>
                            <Icon sx={{fontVariationSettings: "'FILL' 1"}} color={health?.azureHealth?.color ?? 'warning'}>{health?.azureHealth?.icon ?? 'build_circle'}</Icon>
                        </Stack>
                        <Divider />
                        <Stack direction={'row'} justifyContent={'space-between'}  alignItems={'center'} sx={{mt: 1, mb: 1}}>
                            <Typography variant={'body2'}>Inox@Scale API</Typography>
                            <Icon sx={{fontVariationSettings: "'FILL' 1"}} color={health?.apiHealth?.color ?? 'warning'}>{health?.apiHealth?.icon ?? 'build_circle'}</Icon>
                        </Stack>
                        <Divider />
                        <Stack direction={'row'} justifyContent={'space-between'}  alignItems={'center'} sx={{mt: 1}}>
                            <Typography variant={'body2'}>Inox@Scale network</Typography>
                            <Icon sx={{fontVariationSettings: "'FILL' 1"}} color={health?.connectivityHealth?.color ?? 'warning'}>{health?.connectivityHealth?.icon ?? 'build_circle'}</Icon>
                        </Stack>
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}

export default Status